import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-find-us',
    templateUrl: './find-us.component.html',
    styleUrls: ['./find-us.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FindUsComponent implements OnInit {
  map: mapboxgl.Map;
  style = 'mapbox://styles/mapbox/streets-v11';
  lat = 59.60517;
  lng = 17.90287;

  constructor() {}

  ngOnInit(): void {
    Object.getOwnPropertyDescriptor(mapboxgl, 'accessToken').set(environment.mapbox.accessToken);
    this.map = new mapboxgl.Map({
      container: 'map',
      style: this.style,
      zoom: 13,
      center: [this.lng, this.lat]
    });
    // Add map controls
    // this.map.addControl(new mapboxgl.NavigationControl());

    const marker1 = new mapboxgl.Marker().setLngLat([this.lng, this.lat]).addTo(this.map);
  }
}
